import React from "react";
import { InvoiceCurbPassSetup } from "@app.automotus.io/components/scenes/SignUp/InvoiceCurbPassSetup";

export const InvoiceSignupCurbPass: React.FC = () => {
  return <InvoiceCurbPassSetup />;
};

export default InvoiceSignupCurbPass;
